import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import PageTitle from '../UI/PageTitle'
import EditReferenceValue from './EditReferenceValue'
import BackButton from '../UI/BackButton'
import LinearLoader from '../UI/LinearLoader'
import ReferenceValueNotFound from './ReferenceValueNotFound'

import Resource from '../../stores/resource'
const ReferenceValueStore = Resource('reference-values')

class EditReferenceValuePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      referenceValue: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    ReferenceValueStore.find(this.props.match.params.id)
    .then((result) => this.setState({referenceValue: result.data, loading: false}))
    .catch((error) => this.setState({referenceValue: {}, error: errors.unpack(error), loading: false}))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      loading,
      error,
      referenceValue
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(referenceValue)) return (<ReferenceValueNotFound/>)

    return (
      <section>
        <header>
          <PageTitle>
            Edit reference value
          </PageTitle>
        </header>

        <EditReferenceValue referenceValue={referenceValue} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditReferenceValuePage



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/EditReferenceValuePage.jsx